{
  "id": "weekend-pm",
  "label": "Helg-pm",
  "sectionOrder": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje", "Sport"],
  "defaultSpanDays": 2,
  "titleFollowsSpan": true,
  "leadDays": 1,
  "dayGrouping": true,
  "dayHeading": "{DAYNAME}",
  "planning": {
    "titlePattern": "TT:s pm för helgen den {dateRange}",
    "slugline": "TT-helg-pm {shortDateRange}"
  },
  "variants": [
    {
      "id": "friday-weekend",
      "label": "Fredag-söndag",
      "startWeekday": 5,
      "titlePattern": "TT:s pm för fredag och helg den {dateRange}",
      "slugline": "TT-fredag-helg-pm {shortDateRange}",
      "preamble": ["Inför morgondagen och helgen vill vi tipsa om följande:"]
    },
    {
      "id": "weekend-monday",
      "label": "Lördag-måndag",
      "startWeekday": 6,
      "titlePattern": "TT:s pm för helg och måndag den {dateRange}",
      "slugline": "TT-helg-måndag-pm {shortDateRange}",
      "preamble": ["Inför helgen och måndagen vill vi tipsa om följande:"]
    }
  ],
  "sources": [
    { "type": "planning", "newsvalues": ["3", "4", "5", "6"] },
    { "type": "event", "newsvalues": ["3", "4", "5", "6"] }
  ],
  "postamble": [
    "TT:s planeringar för text och bild/video kan även följas här: https://tt.se/planering/lista/, samt TT:s kalender: https://tt.se/kalender/lista/.",
    "Frågor om TT:s planering besvaras av tjänstgörande nyhetschef som nås på telefon 08-692 27 00. Redaktionen nås också via mejl: redaktionen@tt.se."
  ],
  "blocks": [
    {
      "id": "material",
      "label": "Material",
      "preamble": [],
      "grouping": "section",
      "sectionHeadings": [
        { "section": "Inrikes", "heading": "Inrikes" },
        { "section": "Utrikes", "heading": "Utrikes" },
        { "section": "Ekonomi", "heading": "Ekonomi" },
        { "section": "Kultur och nöje", "heading": "Kultur och nöje" },
        { "section": "Sport", "heading": "Sport" }
      ],
      "otherSectionHeading": "Övrigt",
      "topNews": { "heading": "Toppnyheter", "types": ["planning"], "newsvalues": ["5", "6"] },
      "item": {
        "headline": "{headline}",
        "lines": ["{publicDescription}"],
        "assignmentLines": [
          { "types": ["text"], "pattern": "Text: {slugline}: {assignmentTitle}" },
          {
            "types": ["picture", "picture/video", "video"],
            "labels": {
              "picture": "Bild",
              "picture/video": "Bild/video",
              "video": "Video"
            },
            "pattern": "{assignmentLabel}: {assignmentTitle}"
          }
        ]
      },
      "eventItem": {
        "headline": "{time} - {headline} {publicDescription}",
        "lines": []
      },
      "eventTitleSections": ["Sport"],
      "eventsHeading": ["Presskonferenser och övrigt"]
    }
  ]
}
